var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.5C15.5114 4.83218 16.6621 5.4932 17.5844 6.41557C18.5068 7.33793 19.1678 8.48858 19.5 9.75",
    stroke: "#252A42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5C15.0488 7.91438 16.0856 8.95125 16.5 10.5",
    stroke: "#252A42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 14.3757C14.7654 14.3066 14.8849 14.2645 15.0091 14.2532C15.1334 14.2419 15.2585 14.2618 15.3731 14.311L19.7944 16.292C19.9434 16.3557 20.0677 16.4659 20.1489 16.6062C20.23 16.7464 20.2635 16.9092 20.2444 17.0701C20.0987 18.1586 19.5627 19.1571 18.736 19.88C17.9093 20.6029 16.8482 21.0009 15.75 21.0001C12.3685 21.0001 9.12548 19.6568 6.73439 17.2657C4.3433 14.8746 3 11.6316 3 8.2501C2.99916 7.15192 3.3972 6.0908 4.12009 5.2641C4.84298 4.4374 5.84152 3.90138 6.93 3.75573C7.09091 3.73661 7.25368 3.77012 7.39395 3.85124C7.53422 3.93236 7.64444 4.05673 7.70813 4.20573L9.68906 8.63073C9.73774 8.74438 9.75756 8.8683 9.74676 8.99146C9.73596 9.11463 9.69489 9.23321 9.62719 9.33666L7.62375 11.7189C7.55269 11.8261 7.51066 11.9499 7.50179 12.0783C7.49291 12.2066 7.51749 12.335 7.57313 12.451C8.34844 14.0382 9.98906 15.6592 11.5809 16.427C11.6975 16.4824 11.8266 16.5064 11.9553 16.4967C12.084 16.487 12.208 16.4439 12.315 16.3717L14.6616 14.3757Z",
    stroke: "#252A42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.35ee7e4a80ff468367c3db71eef37533.svg";
export { ForwardRef as ReactComponent };